import type { TFunction } from "i18next";

export const formatNumber = (
  t: TFunction,
  value: number,
  decimals?: number,
): string => {
  return t("common:amount", {
    amount: value,
    formatParams: {
      amount: {
        style: "decimal",
        minimumFractionDigits: decimals ?? 2,
        maximumFractionDigits: decimals ?? 2,
      },
    },
  });
};

export const roundUpperNatural = (value: number): number => {
  if (value <= 0) return 0;
  return Math.ceil(value);
};

export const roundLowerNatural = (value: number): number => {
  if (value <= 0) return 0;
  return Math.floor(value);
};

export const clamp = (value: number, min: number, max: number): number => {
  return Math.min(Math.max(value, min), max);
};

export const divideOrZero = (a: number, b: number): number => {
  if (b === 0) return 0;
  return a / b;
};
